import { Select } from 'components';
import { DEALER_TICKETS_STATUS } from 'constants/constants';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface IArchivalComponentProps {
  archiveStatus: boolean | undefined;
  setArchiveStatus: (status?: boolean) => void;
}

export const ArchivalComponent = ({
  archiveStatus,
  setArchiveStatus,
}: IArchivalComponentProps) => {
  const { t } = useTranslation();
  const ARCHIVALOPTIONS = [
    {
      value: DEALER_TICKETS_STATUS.ALL,
      label: t('dealerManagement.tickets.all'),
    },
    {
      value: DEALER_TICKETS_STATUS.ACTIVE,
      label: t('customerManagement.actions.unarchiveItem'),
    },
    {
      value: DEALER_TICKETS_STATUS.ARCHIVED,
      label: t('customerManagement.actions.archiveItem'),
    },
  ];

  const handleArchive = (selectedOption: { value: boolean | undefined }) => {
    setArchiveStatus(selectedOption.value);
  };

  const getSelectedValue = (status: boolean | undefined) => {
    const foundOption = ARCHIVALOPTIONS.find((option) => {
      return option.value === status;
    });
    return foundOption || ARCHIVALOPTIONS[0];
  };

  return (
    <>
      <Row style={{ alignItems: 'baseline' }}>
        <Col lg={4} />
        <Col lg={3} className="text-right">
          <h6 className="h6-short">
            {t('customerManagement.actions.archiveLabel')}:
          </h6>
        </Col>
        <Col lg={5}>
          <Select
            options={ARCHIVALOPTIONS}
            value={getSelectedValue(archiveStatus)}
            defaultValue={ARCHIVALOPTIONS[1]}
            onChange={(selectedOption) => {
              handleArchive(selectedOption);
            }}
            isSearchable
            menuPortalTarget={document.body}
            menuPosition="fixed"
            menuPlacement="auto"
            size="sm"
            extendedClass="select-custom"
            styles={{
              option: (base: any) => ({
                ...base,
                fontSize: '0.725rem',
              }),
            }}
          />
        </Col>
      </Row>
    </>
  );
};
